export default __webpack_public_path__ + "static/media/globe_gray.e74d41d7.svg";